// extracted by mini-css-extract-plugin
module.exports = {"calculator-page":"page_calculator-page__QqTNt","calculator":"page_calculator__2rhHJ","buttons":"page_buttons__1hFqG"};